// Action Types
export const SHOW_ASSIGN_LATER = 'SHOW_ASSIGN_LATER';
export const HIDE_ASSIGN_LATER = 'HIDE_ASSIGN_LATER';
export const SUBMIT_ASSIGN_LATER = 'SUBMIT_ASSIGN_LATER';



// WEBPACK FOOTER //
// ./components/assign-later/store/assign-later.actions.js